<template>
  <div class="searchResult">
    <template v-if="Data.list.length > 0">
      <div class="title">以下是为您搜索到的结果：</div>
      <div class="con">
        <div class="item" v-for="item in Data.list">
          <div class="picWrap">
            <div style="height: 33px">
              <div v-if="item.isLimitTime" class="limitTimeWrap">
                <span class="limitTime">{{ endTime(item.endTime) }}停售</span>
              </div>
            </div>
            <el-tooltip effect="dark" :content="item.goodsDesc">
              <img :src="item.goodsIcon" alt="" style="max-width: 100px;" />
            </el-tooltip>
            <div
              class="limitWrap"
              v-if="item.goodsType == 1 && item.buyMaxCount > 0"
            >
              <span class="limit">限购{{ item.buyMaxCount }}件</span>
            </div>
          </div>
          <div class="name">{{ item.goodsName }}</div>
          <div class="moneyWrap">
            <template v-if="item.currencyName == '金龙元宝'">
              <Tip :titInd="0" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            <template v-else-if="item.currencyName == '银龙元宝'">
              <Tip :titInd="1" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            <template v-else-if="item.currencyName == '积分'">
              <Tip :titInd="2" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            <template v-else-if="item.currencyName == '精品券'">
              <Tip :titInd="3" style="width:20px;vertical-align: bottom"></Tip>
            </template>
            {{ item.goodsPrice }}
          </div>
          <template v-if="item.isTodayGet == 1">
            <div class="buyBtn buyBtn1">购买</div>
          </template>
          <template v-else>
            <div v-if="item.vipLevel == 0" class="buyBtn" @click="hotBuy(item)">
              购买
            </div>
            <div
              v-else-if="!(item.vipLevel <= VipGrade)"
              class="buyBtn"
              @click="NoBuy(item)"
              style="color: #fccf46;"
            >
              仅限vip{{ item.vipLevel }}以上购买
            </div>
            <div v-else class="buyBtn" @click="hotBuy(item)">购买</div>
          </template>
        </div>

        <!-- 分页器 -->
        <div style="width: 100%;float: left;">
          <el-pagination
            style="text-align: center;"
            @current-change="HotGoodPage"
            :page-size="20"
            background
            layout="prev, pager, next"
            :total="hotGoodscounts"
          >
          </el-pagination>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="noResult">
        <img :src="require('@/assets/imgs/shop/noResult.png')" alt="" />
        <div class="tip">很抱歉没有匹配的商品~</div>
      </div>
    </template>
    <pubMask
      v-if="pubMaskIsShow"
      :showWhich="showWhich"
      :goodTitle="goodTitle"
      :goodsPrice="goodsPrice"
      :goodsInfo="goodsInfo"
      :maxCount="maxCount"
      @closeMask="closeMask"
    ></pubMask>
  </div>
</template>

<script>
import Tip from "@/components/Tip";
import axios from "axios";
import eventBus from "@/common/bus.js";
import pubMask from "@/components/pubMask";
import Cookies from "js-cookie";
import {
  indexGoodsListApi,
  getGoodsExchangeApi,
  getGoodsByMaxCountApi,
  searchGoodsListApi
} from "@/api/home/index.js";

export default {
  name: "searchResult",
  components: {
    pubMask,
    Tip,
  },
  props: {
    searchRes: {},
  },
  data() {
    return {
      pubMaskIsShow: false, // 是否显示弹窗
      showWhich: 7, // 当前显示弹窗是购买弹窗
      goodTitle: "", // 商品名称
      goodsPrice: 0, // 商品价格
      maxCount: 1, // 最大购买数量

      VipGrade: "", //vip等级
      hotGoodscounts: 0,
      Data: {
        list: [],
        counts: 0,
      },
    };
  },
  created() {
    console.log(this.searchRes);
  },
  mounted() {
    this.hotGoodscounts = this.searchRes.counts;
    this.Data = this.searchRes;
    setTimeout(() => {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : "";

      if (this.userInfo) {
        this.VipGrade = Number(
          this.userInfo ? this.userInfo.vipInfo.viplevel.match(/\d+/)[0] : 0,
        );
      }
    }, 100);
  },
  methods: {
    closeMask() {
      // 关闭弹窗
      this.pubMaskIsShow = false;
    },
    NoBuy(item) {
      this.$message.info(`仅限vip${item.vipLevel}以上购买`);
    },
    async hotBuy(item) {
      // 热卖购买弹窗
      if (Cookies.get("cwsl_token")) {
        if (item.buyMaxCount == 0 || item.buyMaxCount == null) {
          await getGoodsByMaxCountApi({
            goodsId: item.goodsId,
            platForm: "web",
            userId: Cookies.get("cwsl_userId"),
          }).then((res) => {
            if (res.data.state == 200) {
              this.maxCount = res.data.data.maxCount;
              this.goodsInfo = item;
              this.goodTitle = item.goodsName;
              this.goodsPrice = item.goodsPrice;
              this.showWhich = 7;
              this.pubMaskIsShow = true;
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          this.maxCount = item.buyMaxCount;
          this.goodsInfo = item;
          this.goodTitle = item.goodsName;
          this.goodsPrice = item.goodsPrice;
          this.showWhich = 7;
          this.pubMaskIsShow = true;
        }
      } else {
        this.$message.error("请先登录");
      }
    },

    async HotGoodPage(e) {

      // this.indexGoodsList(1, e);
      await searchGoodsListApi({
        goodsName: this.searchRes.goodsName,
        order: {
          addTime: 0,
        },
        pageNum: e,
        pageSize: 20,
      }).then((res) => {
        if (res.data.state == 200) {
          this.Data = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    endTime(diffTime) {
      let date = new Date(parseInt(diffTime) * 1000);
      let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
      let Hours = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      return Moth + '月' + Day + '日' + Hours + '时'
    }
  },
  watch: {
    searchRes: {
      handler(newVal) {
        console.log("商品列表变化：", newVal);
        this.Data = newVal;
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="less">
.searchResult {
  .title {
    margin-bottom: 10px;
    color: #333;
    font-size: 22px;
  }

  .con {
    margin-right: -10px;

    .item {
      margin-bottom: 20px;
      float: left;
      width: 136px;
      margin-right: 7px;

      .picWrap {
        text-align: center;
        width: 128px;
        height: 120px;
        border: 4px solid #5472f6;
        overflow: hidden;

        img {
          height: 64px;
        }

        .limitTimeWrap {
          padding-top: 8px;
          text-align: center;
          background: url("../../../assets/imgs/shop/superValueLimit.png")
            no-repeat top center;

          .limitTime {
            display: inline-block;
            width: 110px;
            height: 25px;
            color: #fff;
            font-size: 12px;
          }
        }

        .limitWrap {
          .limit {
            margin-top: 2px;
            display: inline-block;
            width: 100px;
            height: 20px;
            line-height: 20px;
            color: #fff;
            font-size: 12px;
            background: #5472f6;
          }
        }
      }

      .name {
        padding: 10px;
        height: 34px;
        font-size: 14px;
        text-align: center;
        color: #333;
        font-weight: 700;
        white-space: nowrap;
        box-sizing: border-box;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .moneyWrap {
        margin-bottom: 8px;
        height: 20px;
        color: #fff;
        background: #555555;
        display: flex;
        justify-content: center;
        align-items: center;
        /*.money{
            display: block;
            width:100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #555555;
          }*/
        /*.moneyUnit{
            width:56px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #fff;
            background: #555555;
          }*/
      }

      .buyBtn {
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        background: #5472f6;
        cursor: pointer;
      }
    }
  }

  .noResult {
    padding-top: 30px;
    text-align: center;

    .tip {
      transform: translateY(-28px);
      font-size: 22px;
    }
  }
}
</style>
